(() => {
  if (customElements.get('product-list-carousel')) {
    return;
  }

  class ProductListCarousel extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.destroyMobile = JSON.parse(this.dataset.destroyMobile);
      this.destroyDesktop = this.dataset.destroyDesktop === 'true';
      /*
        This ternary operator is used to set the default value of the
        hideArrows and hidePagination variables if none found in the dataset
        of the element.
      */

      this.hideArrows = (this.dataset.hideArrows === 'true' ? false : true) ?? true;
      this.hidePagination = (this.dataset.hidePagination === 'true' ? false : true) ?? true;

      this.options = {
        perPage: 5,
        padding: { right: 55 },
        gap: 16,
        arrows: this.hideArrows,
        pagination: this.hidePagination,
        destroy: this.destroyDesktop,
        breakpoints: {
          750: {
            perPage: 2,
            padding: { right: 16 },
            gap: 8,
            destroy: this.destroyMobile
          }
        }
      };

      console.log(this.options);
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      this.slider = new Splide(this,this.options).mount();
    }
  }

  customElements.define('product-list-carousel', ProductListCarousel);
})();
